import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(({ palette }: Theme) => ({
  layout: {
    height: "calc(100vh - 72px - 72px)",
    boxSizing: "border-box",
  },
  main: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  buttons: {
    width: "100%",
    height: 72,
    display: "flex",
    justifyContent: "flex-end",
    position: "fixed",
    padding: "16px 48px 0 0",
    bottom: 0,
    right: 0,
    borderTop: `1px solid ${palette.grey[300]}`,
    background: "white",
    gap: 16,
  },
}));
